import { AmChartsService } from '@amcharts/amcharts3-angular';
import { Component } from '@angular/core';
import { ChartRelativeInput, LinesChartParams } from 'emma-common-ts/emma';
import { orderBy } from 'lodash';

import { EMMAChartAms } from './emma-chart-ams';
import { getOptions, lineStyles } from './emma-funnelchart.component.helpers';

export type FunnelChartGraph = Pick<LinesChartParams, 'title' | 'label' | 'loading' | 'index'> & {
  value: number;
};
export interface FunnelChartInput {
  graph: FunnelChartGraph;
  error?: Error;
}

@Component({
    selector: 'emma-funnelchart',
    templateUrl: './emma-chart.template.html',
    standalone: false
})
export class EMMAFunnelChartComponent extends EMMAChartAms {
  constructor(protected override AmCharts: AmChartsService) {
    super(AmCharts);
    this.data = { graphs: [] };
  }

  protected override getOptions(): any {
    return getOptions();
  }

  protected override getLineStyles(): any {
    return lineStyles;
  }

  protected override _updateChart = () => {
    if (!this.chart) {
      console.warn('No Chart to update');
      return;
    }
    const chartGraphs: any[] = [];
    this.data.graphs.forEach((graph: FunnelChartGraph, i: number) => {
      if (graph) {
        const style: any = { ...this.getLineStyles()[i] };
        chartGraphs.push({
          ...style,
          ...graph,
        });
      }
    });

    const chart = this.chart;
    this.AmCharts.updateChart(this.chart, () => {
      chart.dataProvider = orderBy(chartGraphs, 'index');
    });
  };

  private _addValue(graph: FunnelChartGraph) {
    const idx = this.data.graphs.findIndex((g: any) => g.index === graph.index);
    if (idx >= 0) {
      this.data.graphs[idx] = { ...graph };
    } else {
      this.data.graphs.push(graph);
    }
  }

  addValue(graph: FunnelChartGraph, options: any = {}) {
    if (graph) {
      this._addValue(graph);
    }
  }

  addValues(graphs: FunnelChartGraph[], options: any = {}) {
    // clean graphic if data is empty
    if (!graphs.length) {
      this.reset();
      return;
    }

    graphs.forEach((graph) => {
      this._addValue(graph);
    });

    this.updateChart();
  }

  override update(dataArray: ChartRelativeInput[], options?: any) {
    if (!Array.isArray(dataArray)) {
      return console.error('Funnel data is not an array', dataArray);
    }
    const error = dataArray.find((c) => Boolean(c && c.error));
    const loading = dataArray.find((c) => Boolean(c && c.loading));
    if (error) {
      return this.error(error.error);
    } else if (loading) {
      return this.loading();
    } else {
      this.addValues(
        dataArray.map((data) => ({
          title: data.title || data.label,
          label: data.label,
          value: data.total,
          index: data.index,
          percent: data.percent || '',
        })),
        options
      );
      this.loaded();
    }
  }
}
